import { render, staticRenderFns } from "./CheckboxIcon.vue?vue&type=template&id=44a5f51b"
import script from "./CheckboxIcon.vue?vue&type=script&lang=js"
export * from "./CheckboxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports